import React from 'react';

import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { ServerSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedServerSettingsSpace } from './ServerSettingsSpace';

export interface ServerSettingsSpaceProviderProps {
  readonly subspaceName: ServerSettingsSubspaceName;
}

export function ServerSettingsSpaceProvider(props: ServerSettingsSpaceProviderProps) {
  const spaceInfo: SpaceInfo = {
    spaceType: 'serversettings',
    subspaceName: props.subspaceName,
    item: SpaceItemForNonEntitySpace
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedServerSettingsSpace {...props} server={getSessionManagementServiceInstance()}/>
    </ConnectedSpaceInfoProvider>
  );
}
